
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/feed",
      function () {
        return require("private-next-pages/groups/feed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/feed"])
      });
    }
  